import styled, { createGlobalStyle } from 'styled-components';

const DivContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 2rem 0;
`;

const DivIntroContainer = styled.div`
  width: 100%;
  max-width: 600px;
  text-align: center;
`;

const PIntroText = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  margin-bottom: 1.5rem;
  white-space: pre-line;
`;

const ButtonOpenForm = styled.button`
  background: linear-gradient(45deg, #4ecdc4, #44a08d);
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 700;
  padding: 12px 24px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(78, 205, 196, 0.3);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(78, 205, 196, 0.4);
    background: linear-gradient(45deg, #44a08d, #4ecdc4);
  }

  &:active {
    transform: translateY(-1px);
  }
`;

const DivModalOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  animation: ${({ isOpen }) => (isOpen ? 'fadeIn 0.3s ease-out' : 'none')};

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const DivModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2rem;
  max-width: 550px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
    max-height: 95vh;
  }
`;

const ButtonCloseModal = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  font-size: 28px;
  color: #666;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
    color: #333;
  }
`;

const DivFormContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding-top: 2rem;
`;

// Styles globaux pour le formulaire HubSpot
export const HubspotFormStyles = createGlobalStyle`
  /* Style global du formulaire HubSpot */
  .formStyle {
    width: 100%;
    text-align: center;
  }

  .formStyle select, .formStyle option:disabled {
    color: #BBB;
}
  .formStyle option {
      color: #333;
  }

  .formStyle fieldset {
    max-width: 100%;
    text-align: left;
    border: none;
    padding: 0;
    margin: 0;
  }

  /* Labels */
  .formStyle label {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    display: flex;
    align-items: center;
  }

  .formStyle legend {
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    color: #666;
  }

  .formStyle ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  /* Messages d'erreur */
  .formStyle .hs-error-msg,
  .formStyle .hs-error-msgs {
    color: #ff6b6b;
    font-size: 12px;
    margin-top: 5px;
    padding-left: 5px;
  }

  /* Champs de formulaire - Style modernisé */
  .formStyle input,
  .formStyle select,
  .formStyle textarea {
    border: 2px solid #e1e5e9;
    box-sizing: border-box;
    border-radius: 12px;
    box-shadow: none;
    padding: 12px 16px !important;
    font-family: 'Montserrat', sans-serif;
    min-height: 50px;
    width: 100% !important;
    background-color: #fff;
    color: #333;
    font-size: 16px;
    transition: all 0.3s ease;
  }

  /* Focus state - effet moderne */
  .formStyle input:focus,
  .formStyle select:focus,
  .formStyle textarea:focus {
    outline: none;
    border-color: #4ECDC4;
    box-shadow: 0 0 0 3px rgba(78, 205, 196, 0.1);
  }

  .formStyle textarea {
    min-height: 120px;
    resize: vertical;
  }

  /* Checkbox et Radio - style modernisé */
  .formStyle input[type="checkbox"],
  .formStyle input[type="radio"] {
    min-height: 20px;
    width: 20px !important;
    margin-bottom: 0;
    margin-right: 10px;
    cursor: pointer;
    accent-color: #4ECDC4;
  }

  .formStyle input[type="radio"] + span,
  .formStyle input[type="checkbox"] + span {
    font-size: 14px;
    color: rgb(80, 80, 80);
    line-height: 1.4;
  }

  /* Masquer l'astérisque requis */
  .formStyle .hs-form-required {
    display: none;
  }

  /* Rich text */
  .formStyle .hs-richtext {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px !important;
    color: #666;
    line-height: 1.5;
    margin-bottom: 15px;
  }

  .formStyle .hs-richtext h3 {
    font-size: 16px !important;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }

  /* Actions et bouton de soumission */
  .formStyle .actions {
    text-align: center;
    margin-top: 10px;
  }

  .formStyle input[type="submit"] {
    background: linear-gradient(45deg, #4ECDC4, #44A08D);
    color: #ffffff;
    margin-top: 10px;
    box-shadow: 0 4px 12px rgba(78, 205, 196, 0.3);
    font-size: 16px;
    font-weight: 700;
    width: 80% !important;
    max-width: 80%;
    padding: 18px 24px;
    cursor: pointer;
    border: none;
    border-radius: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    transition: all 0.3s ease;
    min-height: auto;
  }

  .formStyle input[type="submit"]:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(78, 205, 196, 0.4);
    background: linear-gradient(45deg, #44A08D, #4ECDC4);
  }

  /* Téléphone international */
  .hs-fieldtype-intl-phone.hs-input {
    margin-bottom: 15px;
    width: 100% !important;
  }

  .hs-fieldtype-intl-phone .hs-input {
    display: grid;
    grid-template-columns: 120px 1fr;
    gap: 10px;
  }

  .hs-fieldtype-intl-phone select {
    border: 2px solid #e1e5e9;
    border-radius: 12px;
    padding: 16px 15px;
    font-size: 16px;
    background: white;
    cursor: pointer;
  }

  /* Groupe de champs côte à côte */
  .formStyle .hs-form-field {
    margin-bottom: 15px;
  }

  /* Message de succès */
  .submitted-message {
    text-align: center;
    padding: 30px;
    background: rgba(78, 205, 196, 0.1);
    border-radius: 12px;
    color: #333;
  }

  /* Section lien étudiant */
  .student-link-section {
    text-align: center;
    margin-top: 25px;
    padding-top: 25px;
    border-top: 1px solid #FFFF;
  }

  .student-text {
    font-size: 14px;
    color: #ffffff;
    margin-bottom: 8px;
    line-height: 1.5;
    font-family: 'Montserrat', sans-serif;
  }

  .student-cta {
    color: #4ECDC4;
    text-decoration: none;
    font-weight: 600;
    font-size: 14px;
    transition: color 0.3s ease;
    font-family: 'Montserrat', sans-serif;
  }

  .student-cta:hover {
    color: #44A08D;
    text-decoration: underline;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .formStyle input,
    .formStyle select,
    .formStyle textarea {
      padding: 14px 18px;
      font-size: 16px; /* Évite le zoom automatique sur iOS */
    }

    .hs-fieldtype-intl-phone .hs-input {
      grid-template-columns: 100px 1fr;
    }
  }

  /* Loading state */
  .formStyle .hs-submit .hs-button.loading {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export default {
  DivContainer,
  DivFormContainer,
  DivIntroContainer,
  PIntroText,
  ButtonOpenForm,
  DivModalOverlay,
  DivModalContent,
  ButtonCloseModal,
};
